var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
// @ts-nocheck
import { createContext, useContext, useState, useCallback, useMemo } from 'react';
import { useDataProvider, useTranslate, useNotify } from 'react-admin';
// Dashboard Data Context for sharing data between components
var DashboardDataContext = createContext(null);
// Dashboard Data Provider Hook
var useDashboardData = function () {
    var context = useContext(DashboardDataContext);
    if (!context) {
        throw new Error('useDashboardData must be used within DashboardDataProvider');
    }
    return context;
};
// Dashboard Data Provider Component
var DashboardDataProvider = function (_a) {
    var children = _a.children;
    var dataProvider = useDataProvider();
    var translate = useTranslate();
    var notify = useNotify();
    // Centralized data state
    var _b = useState({
        // All Organizations data
        allOrg: {
            cards: null,
            barData: null,
            pieData: null,
            loading: false,
            lastFetch: null,
        },
        // Your Organization data
        yourOrg: {
            cards: null,
            barData: null,
            pieData: null,
            loading: false,
            lastFetch: null,
        },
        // Payment data
        payment: {
            data: null,
            loading: false,
            lastFetch: null,
        },
        // Revenue data
        revenue: {
            data: null,
            loading: false,
            lastFetch: null,
        }
    }), dashboardData = _b[0], setDashboardData = _b[1];
    // Cache duration (5 minutes)
    var CACHE_DURATION = 5 * 60 * 1000;
    // Check if data is fresh
    var isDataFresh = useCallback(function (lastFetch) {
        return lastFetch && (Date.now() - lastFetch) < CACHE_DURATION;
    }, []);
    // Fetch All Organizations data
    var fetchAllOrgData = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, Card1Response, Card2Response, Card4Response, AllOrgleftbarResponse, AllOrgPie1Response, AllOrgPie2Response, AllOrgPie3Response, AllOrgPie4Response, AllOrgPie5Response, AllOrgPie6Response, cards, barData, pieData, newData_1, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (dashboardData.allOrg.loading || isDataFresh(dashboardData.allOrg.lastFetch)) {
                        return [2 /*return*/, dashboardData.allOrg];
                    }
                    setDashboardData(function (prev) { return (__assign(__assign({}, prev), { allOrg: __assign(__assign({}, prev.allOrg), { loading: true }) })); });
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, Promise.all([
                            dataProvider.Card1(),
                            dataProvider.Card2(),
                            dataProvider.Card4(),
                            dataProvider.AllOrgleftbar(),
                            dataProvider.AllOrgPie1(),
                            dataProvider.AllOrgPie2(),
                            dataProvider.AllOrgPie3(),
                            dataProvider.AllOrgPie4(),
                            dataProvider.AllOrgPie5(),
                            dataProvider.AllOrgPie6(),
                        ])];
                case 2:
                    _a = _b.sent(), Card1Response = _a[0], Card2Response = _a[1], Card4Response = _a[2], AllOrgleftbarResponse = _a[3], AllOrgPie1Response = _a[4], AllOrgPie2Response = _a[5], AllOrgPie3Response = _a[6], AllOrgPie4Response = _a[7], AllOrgPie5Response = _a[8], AllOrgPie6Response = _a[9];
                    cards = [
                        { title: translate('pages.dashboard.title.totalSubjects'), value: Card1Response.data, label: "Total Subjects" },
                        { title: translate('pages.dashboard.title.totalExams'), value: Card2Response.data, label: "Total Exams" },
                        { title: translate('pages.dashboard.title.unfinishExams'), value: Card2Response.data - Card4Response.data, percentage: "(14.5%)", label: "Unfinished Exams" },
                        { title: translate('pages.dashboard.title.finishedExams'), value: Card4Response.data, percentage: "(85.5%)", label: "Finished Exams" },
                    ];
                    barData = {
                        data1: AllOrgleftbarResponse.data.data1.map(function (item) { return item.value; }),
                        data2: AllOrgleftbarResponse.data.data2.map(function (item) { return item.value; })
                    };
                    pieData = [
                        AllOrgPie1Response.data,
                        {
                            data: AllOrgPie2Response.data.data.map(function (el) { return (__assign(__assign({}, el), { label: (el.label && el.label !== "N/A") ? translate("pages.exam.fields.params.eye.".concat(el.label)) : el.label })); })
                        },
                        {
                            data: AllOrgPie3Response.data.data.map(function (el) { return (__assign(__assign({}, el), { label: (el.label && el.label !== "N/A") ? translate("pages.exam.fields.params.ai_model.".concat(el.label)) : el.label })); })
                        },
                        {
                            data: AllOrgPie4Response.data.data.map(function (el) { return (__assign(__assign({}, el), { label: (el.label && el.label !== "N/A") ? translate("params.subjects.".concat(el.label)) : el.label })); })
                        },
                        {
                            data: AllOrgPie5Response.data.data.map(function (el) { return (__assign(__assign({}, el), { label: (el.label && el.label !== "N/A") ? translate("params.subjects.".concat(el.label)) : el.label })); })
                        },
                        {
                            data: AllOrgPie6Response.data.data.map(function (el) { return (__assign(__assign({}, el), { label: (el.label && el.label !== "N/A") ? translate("params.dashboard.years.".concat(el.label)) : el.label })); })
                        }
                    ];
                    newData_1 = { cards: cards, barData: barData, pieData: pieData, loading: false, lastFetch: Date.now() };
                    setDashboardData(function (prev) { return (__assign(__assign({}, prev), { allOrg: newData_1 })); });
                    return [2 /*return*/, newData_1];
                case 3:
                    error_1 = _b.sent();
                    console.error('Error fetching All Organizations data:', error_1);
                    notify(translate('error.dashboard.fetchData'), { type: 'error' });
                    setDashboardData(function (prev) { return (__assign(__assign({}, prev), { allOrg: __assign(__assign({}, prev.allOrg), { loading: false }) })); });
                    throw error_1;
                case 4: return [2 /*return*/];
            }
        });
    }); }, [dataProvider, translate, notify, dashboardData.allOrg.loading, dashboardData.allOrg.lastFetch, isDataFresh]);
    // Fetch Your Organization data
    var fetchYourOrgData = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, totalSubjectsResponse, totalExamsResponse, totalSubjectsRepResponse, totalSubjectsOrgResponse, totalExamsOrgResponse, finishedExamsResponse, UrOrgleftbarResponse, UrOrgPie1Response, UrOrgPie2Response, UrOrgPie3Response, UrOrgPie4Response, UrOrgPie5Response, UrOrgPie6Response, cards, barData, pieData, newData_2, error_2;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (dashboardData.yourOrg.loading || isDataFresh(dashboardData.yourOrg.lastFetch)) {
                        return [2 /*return*/, dashboardData.yourOrg];
                    }
                    setDashboardData(function (prev) { return (__assign(__assign({}, prev), { yourOrg: __assign(__assign({}, prev.yourOrg), { loading: true }) })); });
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, Promise.all([
                            dataProvider.totalSubjects("dashboard"),
                            dataProvider.totalExams("dashboard"),
                            dataProvider.totalSubjectsRep("dashboard"),
                            dataProvider.totalSubjectsOrg("dashboard"),
                            dataProvider.totalExamsOrg("dashboard"),
                            dataProvider.FinishedExams("dashboard"),
                            dataProvider.UrOrgleftbar(),
                            dataProvider.UrOrgPie1(),
                            dataProvider.UrOrgPie2(),
                            dataProvider.UrOrgPie3(),
                            dataProvider.UrOrgPie4(),
                            dataProvider.UrOrgPie5(),
                            dataProvider.UrOrgPie6(),
                        ])];
                case 2:
                    _a = _b.sent(), totalSubjectsResponse = _a[0], totalExamsResponse = _a[1], totalSubjectsRepResponse = _a[2], totalSubjectsOrgResponse = _a[3], totalExamsOrgResponse = _a[4], finishedExamsResponse = _a[5], UrOrgleftbarResponse = _a[6], UrOrgPie1Response = _a[7], UrOrgPie2Response = _a[8], UrOrgPie3Response = _a[9], UrOrgPie4Response = _a[10], UrOrgPie5Response = _a[11], UrOrgPie6Response = _a[12];
                    cards = [
                        { title: translate('pages.dashboard.title.totalSubjects'), subtitle: translate('pages.dashboard.title.cbu'), value: totalSubjectsResponse.data, label: "Total Subjects" },
                        { title: translate('pages.dashboard.title.totalExams'), subtitle: translate('pages.dashboard.title.cbu'), value: totalExamsResponse.data, label: "Total Exams" },
                        { title: translate('pages.dashboard.title.generatedReports'), value: totalSubjectsRepResponse.data, label: "Generated Reports" },
                        { title: translate('pages.dashboard.title.advancedYearly'), subtitle: translate('pages.dashboard.title.until20241231'), value: 0, highlight: true, label: "Advanced - Yearly" },
                        { title: translate('pages.dashboard.title.totalSubjects'), subtitle: translate('pages.dashboard.title.iuo'), value: totalSubjectsOrgResponse.data, label: "Total Subjects" },
                        { title: translate('pages.dashboard.title.totalExams'), subtitle: translate('pages.dashboard.title.iuo'), value: totalExamsOrgResponse.data, label: "Total Exams" },
                        { title: translate('pages.dashboard.title.unfinishExams'), subtitle: translate('pages.dashboard.title.iuo'), value: totalExamsOrgResponse.data - finishedExamsResponse.data, percentage: "(0%)", label: "Unfinished Exams" },
                        { title: translate('pages.dashboard.title.finishedExams'), subtitle: translate('pages.dashboard.title.iuo'), value: finishedExamsResponse.data, percentage: "(0%)", label: "Finished Exams" },
                    ];
                    barData = {
                        data1: UrOrgleftbarResponse.data.data1.map(function (item) { return item.value; }),
                        data2: UrOrgleftbarResponse.data.data2.map(function (item) { return item.value; })
                    };
                    pieData = [
                        UrOrgPie1Response.data,
                        {
                            data: UrOrgPie2Response.data.data.map(function (el) { return (__assign(__assign({}, el), { label: (el.label && el.label !== "N/A") ? translate("pages.exam.fields.params.eye.".concat(el.label)) : el.label })); })
                        },
                        {
                            data: UrOrgPie3Response.data.data.map(function (el) { return (__assign(__assign({}, el), { label: (el.label && el.label !== "N/A") ? translate("pages.exam.fields.params.ai_model.".concat(el.label)) : el.label })); })
                        },
                        {
                            data: UrOrgPie4Response.data.data.map(function (el) { return (__assign(__assign({}, el), { label: (el.label && el.label !== "N/A") ? translate("params.subjects.".concat(el.label)) : el.label })); })
                        },
                        {
                            data: UrOrgPie5Response.data.data.map(function (el) { return (__assign(__assign({}, el), { label: (el.label && el.label !== "N/A") ? translate("params.subjects.".concat(el.label)) : el.label })); })
                        },
                        {
                            data: UrOrgPie6Response.data.data.map(function (el) { return (__assign(__assign({}, el), { label: (el.label && el.label !== "N/A") ? translate("params.dashboard.years.".concat(el.label)) : el.label })); })
                        }
                    ];
                    newData_2 = { cards: cards, barData: barData, pieData: pieData, loading: false, lastFetch: Date.now() };
                    setDashboardData(function (prev) { return (__assign(__assign({}, prev), { yourOrg: newData_2 })); });
                    return [2 /*return*/, newData_2];
                case 3:
                    error_2 = _b.sent();
                    console.error('Error fetching Your Organization data:', error_2);
                    notify(translate('error.dashboard.fetchData'), { type: 'error' });
                    setDashboardData(function (prev) { return (__assign(__assign({}, prev), { yourOrg: __assign(__assign({}, prev.yourOrg), { loading: false }) })); });
                    throw error_2;
                case 4: return [2 /*return*/];
            }
        });
    }); }, [dataProvider, translate, notify, dashboardData.yourOrg.loading, dashboardData.yourOrg.lastFetch, isDataFresh]);
    // Invalidate cache function
    var invalidateCache = useCallback(function (section) {
        if (section === void 0) { section = null; }
        if (section) {
            setDashboardData(function (prev) {
                var _a;
                return (__assign(__assign({}, prev), (_a = {}, _a[section] = __assign(__assign({}, prev[section]), { lastFetch: null }), _a)));
            });
        }
        else {
            setDashboardData(function (prev) { return ({
                allOrg: __assign(__assign({}, prev.allOrg), { lastFetch: null }),
                yourOrg: __assign(__assign({}, prev.yourOrg), { lastFetch: null }),
                payment: __assign(__assign({}, prev.payment), { lastFetch: null }),
                revenue: __assign(__assign({}, prev.revenue), { lastFetch: null }),
            }); });
        }
    }, []);
    var contextValue = useMemo(function () { return ({
        dashboardData: dashboardData,
        fetchAllOrgData: fetchAllOrgData,
        fetchYourOrgData: fetchYourOrgData,
        invalidateCache: invalidateCache,
        isDataFresh: isDataFresh,
    }); }, [dashboardData, fetchAllOrgData, fetchYourOrgData, invalidateCache, isDataFresh]);
    return (_jsx(DashboardDataContext.Provider, { value: contextValue, children: children }));
};
export { useDashboardData, DashboardDataProvider };
